<script>
import {PeoAnalyse} from "@/api/personcenter";

export default {
	data() {
		return {
			myData: {},
			user: JSON.parse(this.$store.state.User.infos),
		}
	},
	mounted() {
		PeoAnalyse({userId:this.user.id}).then(res => {
			console.log(res.result);
			let data = res.result;
			this.myData = data;
		})
	},
	methods: {}
}
</script>

<template>
	<div class="wrapper" style="margin-right: 30px;">
		<div class="row bmi">
			<div>
				<div class="">
					<div class="num" style="font-size: 60px;font-weight: bold;">
						{{myData.hwBmi}}
					</div>
					<div class="text"><span style="color: #38FB76">身体质量指数</span>（BMI）</div>
				</div>
			</div>
			<div class="standard">标准值（20.00-22.00）</div>
		</div>
		<h3 class="subheading">核心数据</h3>
		<div style="margin: 15px 0;">
			<div class="row">
				<div :class="{disease:true, blue:myData.hr_state==1}">
					<div class="up">
						<div class="diseaseIcon">
							<img src="/img/personalCenter/icons8-heart-50 (1).png" alt="">
						</div>
						<div class="diseaseName">心率</div>
					</div>
					<div class="diseaseNum">{{myData.hr}}</div>
				</div>
				<div :class="{disease:true, blue:myData.br_face_state==1}">
					<div class="up">
						<div class="diseaseIcon">
							<img src="/img/personalCenter/icons8-breathing-64.png" alt="">
						</div>
						<div class="diseaseName">呼吸</div>
					</div>
					<div class="diseaseNum">{{myData.br_face}}</div>
				</div>
				<div :class="{disease:true, blue:myData.dm_value_state==1}">
					<div class="up">
						<div class="diseaseIcon">
							<img src="/img/icons8-glucometer-50.png" alt="">
						</div>
						<div class="diseaseName">血糖</div>
					</div>
					<div class="diseaseNum">{{myData.dm_value_}}</div>
				</div>
				<div :class="{disease:true, blue:myData.spo2_state==1}">
					<div class="up">
						<div class="diseaseIcon">
							<img src="/img/personalCenter/icons8-blood-oxygen-50.png" alt="">
						</div>
						<div class="diseaseName">血氧</div>
					</div>
					<div class="diseaseNum">{{myData.spo2}}</div>
				</div>
			</div>
			<div class="row" style="margin-top: 20px;">
				<div :class="{disease:true, blue:myData.bp_l_state==1}">
					<div class="up">
						<div class="diseaseIcon">
							<img src="/img/personalCenter/icons8-blood-pressure-32 (1).png" alt="">
						</div>
						<div class="diseaseName">舒张压</div>
					</div>
					<div class="diseaseNum">{{myData.bp_l}}</div>
				</div>
				<div :class="{disease:true, blue:myData.bp_h_state==1}">
					<div class="up">
						<div class="diseaseIcon">
							<img src="/img/personalCenter/icons8-blood-pressure-32 (1).png" alt="">
						</div>
						<div class="diseaseName">收缩压</div>
					</div>
					<div class="diseaseNum">{{myData.bp_h}}</div>
				</div>
			</div>
		</div>
		<h3 class="subheading">基础数据</h3>
		<div style="">
			<table class="info">
				<tr>
					<td>脂肪率</td>
					<td>{{myData.fatRate}}</td>
					<td>体温</td>
					<td>{{myData.templature}}</td>
				</tr>
				<tr>
					<td>左眼视力</td>
					<td>{{myData.leftEyesight}}</td>
					<td>右眼视力</td>
					<td>{{myData.rightEyesight}}</td>
				</tr>
			</table>
		</div>
		<h3 class="subheading">其他数据</h3>
		<div style="">
			<table class="info">
				<tr>
					<td>机能年龄</td>
					<td>{{myData.phy_age}}</td>
					<td>长期压力</td>
					<td>{{['低', '中', '高'][myData.pressure_index]}}</td>
				</tr>
				<tr>
					<td>恢复能力</td>
					<td>{{['低', '中', '高'][myData.resilent_index]}}</td>
					<td>机能活性度</td>
					<td>{{['低', '中', '高'][myData.active_level]}}</td>
				</tr>
				<tr>
					<td>精神状态</td>
					<td>{{ ['清醒', '焦虑', '疲惫', '昏昏欲睡'][myData.instant_status] }}</td>
					<td>心率变异性</td>
					<td>{{ myData.hrv_change }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<style scoped lang="scss">
.row {
	display: flex;
	align-items: center;

	& > div {
		margin-right: 10px;
	}
}

.wrapper {
	color: white;
}

.bmi {
	align-items: flex-end;

	.standard {
		padding-bottom: 3px;
		border-bottom: 1px solid #38FB76;
	}
}

.disease {
	border-radius: 10px;
	border: 1px solid #38FB76;
	overflow: hidden;

	.up {
		padding: 10px 15px;

		.diseaseIcon {
			//width: 100px;
			//height: 100px;
			border-radius: 50%;
			padding: 5px;
			background-color: #38FB76;
			border: 5px solid #1B693C;

			img {
				//display: block;
				width: 40px;
				height: 40px;
			}
		}

		.diseaseName {
			text-align: center;
			color: #00c758;
			margin-top: 5px;
		}
	}

	.diseaseNum {
		background-color: #00c758;
		font-family: 'led2', serif;
		font-size: 26px;
		text-align: center;
	}
}

.disease.blue {
	border: 1px solid #E3CB46;

	.up {
		.diseaseIcon {
			background-color: #E3CB46;
			border: 5px solid #e3ac46;
		}

		.diseaseName {
			color: #E3CB46;
		}
	}

	.diseaseNum {
		background-color: #e3ac46;
	}
}

.earlyWarning {
	display: flex;
	align-items: flex-end;
	padding: 5px 0;
	border-top: 1px solid gray;
	border-bottom: 1px solid gray;
	justify-content: space-between;
	margin-top: 10px;

	.name {
		font-size: 22px;
		text-align: center;
	}

	.date {
		font-size: 16px;
		text-align: center;
		color: gray
	}

	.right {
		display: flex;
		align-items: center;

		i {
			font-size: 30px;
			margin-right: 30px;
		}

		.value {
			display: flex;
			align-items: flex-end;
			width: 150px;
			justify-content: space-between;

			.num {
				font-size: 32px;
				margin-right: 10px;
				line-height: 40px;
			}

			.unit {
				font-size: 24px;
			}
		}
	}
}
.subheading {
	color: white;
	padding: 5px 10px;
	margin-top: 10px;
	margin-bottom: 0;
	border-left: 8px solid transparent; /* 边框宽度 + 透明 */
	border-image: linear-gradient(0deg, #7E237E, #1D21A4);
	border-image-slice: 1; /* 表示渐变图片如何切割，通常设为1 */
}
.info {
	font-size: 20px;
	border-collapse: collapse;
	td{
		border: 1px solid gray;
		padding: 10px;
	}
}
</style>